import React from 'react';
import styles from "./Faq.module.css"
const Faq = ({icon,title,children}) => {
    return (
        <div className={styles.faq}>
            <div className={styles.twocols}>
                <div className={styles.righticon}>
                    <i className={icon}></i>
                </div>
                <div className={styles.leftinfo}>
                    <h1 className={styles.faqleft}>
                        {title}
                    </h1>
                    <p>
                        {children}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Faq;